import { $$, on, doc } from './util.js';

/* The filter field above a page-tree rail (elements/page-tree-rail.html).

   The field names its tree in data-tree-filter; every <li> carries its page
   name, lower-cased, in data-tree-key. A page stays when its own name, an
   ancestor's or a descendant's contains the text, so a match on a section
   keeps all of it and a match on a page keeps the path down to it. Branches
   that keep something open; clearing the field puts back the branches the
   reader had open. Same behaviour as the Reference rail's filter
   (reference.js), for a tree of any depth. */
export function initTreeFilter() {
	$$('input[data-tree-filter]').forEach(function (input) {
		var tree = doc.getElementById(input.getAttribute('data-tree-filter'));
		if (!tree) { return; }
		var empty = tree.parentNode.querySelector('.ref-filter-empty');
		var lists = $$('ul[id]', tree);
		var initial = null;

		function setOpen(list, open) {
			list.hidden = !open;
			var toggle = tree.querySelector('[aria-controls="' + list.id + '"]');
			if (toggle) { toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
		}

		function childList(item) {
			for (var i = 0; i < item.children.length; i++) {
				if (item.children[i].tagName === 'UL') { return item.children[i]; }
			}
			return null;
		}

		// Shows the items of one list that match; returns whether any is shown.
		function walk(list, query, inherited) {
			var any = false;
			Array.prototype.forEach.call(list.children, function (item) {
				var own = inherited || (item.getAttribute('data-tree-key') || '').indexOf(query) !== -1;
				var sub = childList(item);
				var below = sub ? walk(sub, query, own) : false;
				if (sub) { setOpen(sub, below); }
				item.hidden = !(own || below);
				if (own || below) { any = true; }
			});
			return any;
		}

		function restore() {
			if (initial) { lists.forEach(function (list, i) { setOpen(list, initial[i]); }); }
			initial = null;
			$$('li', tree).forEach(function (item) { item.hidden = false; });
			if (empty) { empty.hidden = true; }
		}

		function apply() {
			var query = input.value.trim().toLowerCase();
			if (!query) { restore(); return; }
			// Remember which branches the reader had open, to put them back.
			if (!initial) { initial = lists.map(function (list) { return !list.hidden; }); }
			var any = walk(tree, query, false);
			if (empty) { empty.hidden = any; }
		}

		on(input, 'input', apply);
		on(input, 'keydown', function (e) {
			if (e.key === 'Escape' && input.value) { input.value = ''; apply(); }
		});

		// "/" jumps to the filter, unless the reader is already typing somewhere.
		on(doc, 'keydown', function (e) {
			if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) { return; }
			var target = e.target;
			var tag = target && target.tagName;
			if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (target && target.isContentEditable)) { return; }
			if (!input.offsetParent) { return; }
			e.preventDefault();
			input.focus();
		});
	});
}
